import styled from "styled-components";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { CONNECTION_STATUS } from "../../constants/ConnectionStatus";

export const ListContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: #EEEEEE;
  overflow-x: auto;
  padding: 24px;
`;

export const ListHeader = styled.div`
  width: 100%;
  display: flex;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid  rgba(0, 0, 0, 0.09);
  background: #FAFAFA;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  min-height: 52px;
`;

export const HeaderContent = styled.div`
  width: ${({width}) => width || '100%'};
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  font-weight: 500;
  ${({canOrder}) => canOrder && `
    cursor: pointer;
  `}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledArrowDown = styled(ArrowDownward)`
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
`;

export const StyledArrowUp = styled(ArrowUpward)`
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
`;



export const ListContent = styled.div`
  width: 100%;
  height: 455px;
  align-items: center;
  justify-content: space-between;
  background-color: #FFFFFF;
  overflow-y: auto;

  &::-webkit-scrollbar {
  width: 6px;              /* largura da barra */
}
&::-webkit-scrollbar-thumb {
  background: #aaa;        /* cor da barra */
  border-radius: 4px;
}
&::-webkit-scrollbar-track {
  background: transparent; /* fundo transparente */
}
`;

export const RowContent = styled.div`
  min-width: 100%;
  display: flex;
  padding: 0 16px;
  height: 60px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  &:hover {
    background-color: #f5fafc;
  }
`;

export const CellText = styled.div`
  display: flex;
  gap: 16px;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
`;

export const CellContent = styled.div`
  width: ${({width}) => width || '100%'};
  max-height: 55px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  padding-left: 4px;
  text-overflow: ellipsis;
`;

export const CellContentConnectionStatus = styled.div`
  display: flex;
  padding: 4px 16px;
  text-align: center;
  justify-content: center;
  border-radius: 100px;
  color: #fff;
  font-size: 14px;

  background-color: ${props => {
    switch (props.connectionStatus) {
      case CONNECTION_STATUS.PENDING:
        return '#FF9800';
      case CONNECTION_STATUS.REFUSED:
        return '#E31B0C';
      case CONNECTION_STATUS.NORMAL:
        return '#3B873E';
      default:
        return '#3B873E';
    }
  }};
`;
